<template>
  <div>
    <slot name="header"/>
    <div class="content">
      <div class="wrapper">
        <div class="formContainer">
          <div
            class="form-map"
            :class="open ? 'open' : ''">
            <slot name="form"/>
          </div>
        </div>
        <div
          class="action"
          :class="open ? 'open' : 'closed'">
          <slot
            name="button"/>
        </div>
      </div>
      <div class="map">
        <slot name="map"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    open: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      isLargeScreen: false,
    };
  },
  methods: {
    setIsLargeScreen() {
      this.isLargeScreen = window.innerWidth >= 768;
    },
  },
  created() {
    this.setIsLargeScreen();
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.setIsLargeScreen();
      });
    });
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    text-align: left;
    z-index: 3;
    color: $fb-grey-light-97;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 3px;
    max-height: 100%;
    -webkit-box-shadow: 4px 4px 7px -1px rgba(196,196,196,1);
    -moz-box-shadow: 4px 4px 7px -1px rgba(196,196,196,1);
    box-shadow: 4px 4px 7px -1px rgba(196,196,196,1);
  }
  .form-map {
    background-color: white;
    width: 0;
    transition: all 0.5s ease-in-out;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    padding: 1em 0 1em 0;
    &.open {
      width: 500px;
      padding: 0em 2.5em 1em 2em;
    }
  }
  .content {
    position: relative;
    height: calc(100% - 123px);
    box-sizing: border-box;
  }
  .action {
    position: absolute;
    top: 60px;
    width: 100%;
    box-sizing: border-box;
  }
  .map {
    height: 100%;
    margin-left: 3px;
  }
  .formContainer {
    box-sizing: border-box;
    height: 100%;
  }
  @media only screen and (max-height: 768px) {
    .content {
      height: 100%;
    }
  }
  @media only screen and (max-width: 425px) {
    .content {
      height: 100vh;
    }
    .formContainer {
      height: 100vh;
    }
  }
  @media only screen and (max-width: 375px) {
    .form-map {
      &.open {
        width: 297px;
      }
    }
  }
</style>
